import { Avatar, Select } from 'antd';
import Text from 'components/Text';
import shopSelectors from 'services/selectors/shop';
import { isBookableStaff } from 'utils/staff';
import { toneChip, toneRing, useStaffGroupTone } from 'widgets/Staff/useStaffGroupTone';
import { useMemo } from 'react';
type Props = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
};
const StaffPicker = ({ disabled, placeholder, value: staffId, onChange: setStaffId = () => undefined }: Props) => {
  const _staffsAll = shopSelectors.staff();
  const toneOf = useStaffGroupTone();
  // Memoised so the filtered array keeps a stable identity across renders.
  const staffs = useMemo(() => _staffsAll.filter(isBookableStaff), [_staffsAll]);

  return (
    <Select disabled={disabled} placeholder={placeholder} onChange={setStaffId} value={staffId} style={{ width: 250, height: 'auto', alignSelf: 'stretch' }}>
      {!placeholder && <Select.Option value={''}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} >All</Avatar>
          <Text variant='CONTENT_2'>All staff</Text>
        </div>
      </Select.Option>}
      {staffs?.map(o => (
        <Select.Option key={o.id} value={o.id}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Avatar size={32} src={o.avatar} style={toneRing(toneOf(o.id))}>{o.name?.[0] || 'A'}</Avatar>
            <Text variant='CONTENT_2'><span style={toneChip(toneOf(o.id))}>{o.name}</span></Text>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default StaffPicker;
